import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchArticleFeedbackReport = createAction(constants.FETCH_ARTICLE_FEEDBACK_REPORT)
export const fetchArticleFeedbackReportPending = createAction(constants.FETCH_ARTICLE_FEEDBACK_REPORT_PENDING)
export const fetchArticleFeedbackReportSuccess = createAction(constants.FETCH_ARTICLE_FEEDBACK_REPORT_SUCCESS)
export const fetchArticleFeedbackReportFailed = createAction(constants.FETCH_ARTICLE_FEEDBACK_REPORT_FAILED)